<template>
  <div class="login">
    <el-form :model="input_user" :rules="rules" ref="input_user" 
              label-position="left" label-width="0px" 
              class="demo-ruleForm login-container">
      <div class="logo">
          <img id="ul_login_Image2" src="./imgs/loginlogo.png" class="logoimg">
      </div>
      
      <div class="bee">
          <img src="./imgs/bee.png" class="beeimg">
      </div>

      <el-form-item prop="username">
        <el-input type="text"  placeholder="请输入手机号码" v-model="input_user.username"></el-input>
      </el-form-item>

      <!-- 验证码组件 -->
      <get-verify-code :username='input_user.username'></get-verify-code>
      
      <el-form-item prop="password">
        <el-input type="password" v-model="input_user.password" auto-complete="off" placeholder="请填写新密码！"></el-input>
      </el-form-item>

      <el-form-item prop="password2">
        <el-input type="password" v-model="input_user.password2" auto-complete="off" placeholder="请重复新密码！"></el-input>
      </el-form-item>
      
      <el-form-item style="width:100%;">
        <el-button type="primary" class="bgblue" style="width:100%;" 
                  @click="reset" @keyup.enter="reset"
                   >确定
        </el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import md5 from 'js-md5'
import urls from '../../common/js/urls.js'
import GetVerifyCode from './GetVerifyCode'
export default {
    name: "forget",
    components: {
      GetVerifyCode
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.input_user.password2 !== '') {
            this.$refs.input_user.validateField('password2');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.input_user.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        input_user: {
          username: '',
          password: '',
          password2: '',
          verify_code: '',
        },
        rules: {
          username: [
            { required: true, message: '请输入手机号', trigger: 'blur' }
            //{ pattern: /^1[345678]\d{9}$/, message: '手机号格式错误', trigger: 'blur'}
          ],
          password: [
            { validator: validatePass, trigger: 'blur' },
          ],
          password2: [
            { validator: validatePass2, trigger: 'blur' },
          ]
        }
      }
    },
    methods: {
      // 获取验证码
      setVerifyCode(val) { 
        this.input_user.verify_code = val;
      },
      reset() {
        if (!this.input_user.verify_code) {
          this.$message.error('请填写验证码');
          return false
        }
        this.$refs.input_user.validate((valid) => {
          if (valid) {
            //this.$store.dispatch('userLogin', this.input_user
            var _this = this
            this.axios.post(urls.reset + '?username=' + this.input_user.username + '&password=' + md5(this.input_user.password) + '&verify_code=' + this.input_user.verify_code).then(function(response) {
              if (response.data.code != 200) {
                alert(response.data.msg);
                return false
              }
              _this.$message({
                message: '密码修改成功！请重新登录',
                type: 'success'
              });
              setTimeout(function() { _this.$router.go(-1) }, 1 * 1000)
            })          
          } else {
            return false;
          }
        }); 
      }
      
    }
}
</script>
<style scoped>
 @import "../../common/style/login.css";
</style>



// WEBPACK FOOTER //
// src/components/Log/Forget.vue